import { z } from 'zod';
import type { RefinementCtx } from 'zod';

type PartnershipAdSettingsValidationContext = Pick<RefinementCtx, 'addIssue'>;

export const partnershipIdSchema = z
  .string()
  .refine((value) => value.trim().length > 0, {
    message: 'Can\'t be empty',
  });

export const isPartnershipIdFilled = (
  partnershipId: string | undefined,
): boolean => Boolean(partnershipId?.trim());

export const validatePartnershipIdAtIndex = (
  partnershipId: string | undefined,
  index: number,
  ctx: PartnershipAdSettingsValidationContext,
): void => {
  const result = partnershipIdSchema.safeParse(partnershipId);

  if (result.success) {
    return;
  }

  result.error.issues.forEach((issue) => {
    ctx.addIssue({
      code: 'custom',
      message: issue.message,
      path: ['partnershipAdSettings', index, 'partnershipId'],
    });
  });
};
